function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
(function (factory) {
  "use strict";

  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['jquery'], function ($) {
      return factory($, window, document);
    });
  } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    // CommonJS
    module.exports = function (root, $) {
      if (!root) {
        // CommonJS environments without a window global must pass a
        // root. This will give an error otherwise
        root = window;
      }
      if (!$) {
        $ = typeof window !== 'undefined' ?
        // jQuery's factory checks for a global window
        require('jquery') : require('jquery')(root);
      }
      return factory($, root, root.document);
    };
  } else {
    // Browser
    factory(jQuery, window, document);
  }
})(function ($, window, document, undefined) {
  // eslint-disable-line
  "use strict";

  require('daterangepicker');
  require('daterangepicker/daterangepicker.css');
  var addDateRangePicker = function addDateRangePicker($input, passedOptions) {
    // http://www.daterangepicker.com/#options
    var format = passedOptions.dateRangePickerDateFormat || 'DD-MMM-YYYY';
    var timePicker = false;
    if ($input.closest('th').data("datatableRange") == "datetime") {
      format = passedOptions.dateRangePickerDateTimeFormat || 'YYYY-MM-DD hh:mm:ss'; // this is default Rails Time.now.to_s (no tz)
      timePicker = true;
    }
    var ranges = [];
    var showCustomRangeLabel = false;
    if ($input.closest('th').data("datatablePredefinedRanges")) {
      ranges = $input.closest('th').data("datatablePredefinedRanges");
      showCustomRangeLabel = true;
    }
    $input.daterangepicker({
      autoApply: true,
      timePicker: timePicker,
      timePicker24Hour: true,
      timePickerSeconds: true,
      timePickerIncrement: 5,
      showDropdowns: true,
      locale: {
        format: format
      },
      ranges: ranges,
      alwaysShowCalendars: true,
      // to always show calendar even ranges are visible and user click on Today
      showCustomRangeLabel: showCustomRangeLabel,
      opens: 'left',
      autoUpdateInput: false // we need to disable since it will use todays value,
      // we want initially empty (so we populate on events)
    }).on('apply.daterangepicker', function (ev, picker) {
      return $input.val(picker.startDate.format(format) + ' - ' + picker.endDate.format(format)).change();
    });
  }; // const addDateRangePicker = function($input) {

  return addDateRangePicker;
});